import { locale } from "@src/containers/getLocale";

const noSepLocal = ["ja", "zh"];
export function mergeCityGroupName(
  cityGroup2: string,
  cityGroup3?: string | null,
  language?: string
) {
  if (!cityGroup3) return cityGroup2;
  const localeValue = language || locale();
  return noSepLocal.includes(localeValue)
    ? cityGroup2 + cityGroup3
    : cityGroup2 + ", " + cityGroup3;
}
